import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";

const ITEMS = [
  { id: 1, name: 'Tenanted' },
  { id: 2, name: 'Vacant' }
]

@Injectable({
  providedIn: 'root'
})
export class OccupancyStatusService {
  private _items$ = new BehaviorSubject(ITEMS)
  options$ = this._items$.asObservable()
    .pipe(
      map(items => items.map(item => ({value: item.id, label: item.name})))
    )
}